import { QuestionConfigurator } from './question';
import { MultipleSelectionView } from '../view';
import { MultipleSelectionValidator } from '../validator';

export class MultipleSelectionConfigurator extends QuestionConfigurator {
  constructor({
    serverContext, configuration, i18n, surveyConfigurator,
  }) {
    super({
      serverContext, configuration, i18n, surveyConfigurator,
    });
    this.setOptionKeyToText();
  }

  get view() {
    return MultipleSelectionView;
  }

  getDefaultData(): Object {
    return {
      ...this.data,
    };
  }

  initValidator() {
    this.validator = new MultipleSelectionValidator();
  }

  setOptionKeyToText() {
    const { options } = this.configuration;
    this.optionKeyToText = {};
    options.forEach((option) => {
      this.optionKeyToText[option.key] = option.text;
    });
  }

  getDefaultDirtyState(bool): Object {
    const state = {
      isDirty: bool,
    };
    const { options } = this.configuration;
    options.forEach((option) => {
      const { key } = option;
      state[key] = bool;
    });
    return state;
  }

  // get the feedback data for sending to the OCV service
  getFeedbackData(answers: any): any {
    const { options } = this.configuration;
    const data = answers[this.key];
    const selectedOptions =
      options.filter(option => data[option.key]?.selected)
        .map(option => ({
          text: this.optionKeyToText[option.key],
          input: data[option.key].input,
        }));
    return {
      key: this.key,
      type: 'multiple-selection',
      title: this.getTitle(answers),
      answer: selectedOptions,
    };
  }
}
